const StickerSetter = require('./sticker');

module.exports = StickerSetter;
